export function getdata() {
	var obj = {
		headData: [{
				title: "项目",
				prop: 'title',
				width: "320px",
				custom: true,
				
			},
			{
				title: "行次",
				prop: 'grade',
				width: "100px",
			},
			{
				title: "本期金额",
				prop: "cwbbyzx_1_x_1",
				custom: true,
				width: "200px",
				
			},
			{
				title: '上期金额',
				prop: 'cwbbyzx_1_x_2',
				width: "200px",
				custom: true,
				
			},
		],
		tableData: [{
				title: "一、营业收入",
				grade: '1',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				title: "减：营业成本",
				grade: '2',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "税金及附加",
				grade: '3',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "销售费用",
				grade: '4',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_4_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_4_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "管理费用",
				grade: '5',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_5_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_5_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "研发费用",
				grade: '6',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_6_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_6_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "财务费用",
				grade: '7',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_7_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_7_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：利息费用",
				grade: '8',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_8_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_8_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "利息收入",
				grade: '9',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_9_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_9_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "加：其他收益",
				grade: '10',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_10_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_10_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "投资收益（损失以“-”号填列）",
				grade: '11',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_11_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_11_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：对联营企业和合营企业的投资收益",
				grade: '12',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_12_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_12_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "以摊余成本计量的金融资产终止确认收益（损失以“-”号填列）",
				grade: '13',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_13_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_13_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "净敞口套期收益（损失以“-”号填列）",
				grade: '14',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_14_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_14_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "公允价值变动收益（损失以“-”号填列）",
				grade: '15',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_15_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_15_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "信用减值损失（损失以“-”号填列）",
				grade: '16',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "资产减值损失（损失以“-”号填列）",
				grade: '17',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_17_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_17_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "资产处置收益（损失以“-”号填列）",
				grade: '18',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_18_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_18_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "二、营业利润（亏损以“-”号填列）",
				grade: '19',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_19_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_19_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "加：营业外收入",
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				grade: '20',
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_20_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_20_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "减：营业外支出",
				grade: '21',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_21_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_21_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "三、利润总额（亏损总额以“-”号填列）",
				grade: '22',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_22_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_22_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "减：所得税费用",
				grade: '23',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_23_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_23_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "四、净利润（净亏损以“-”号填列）",
				grade: '24',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_24_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_24_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "（一）持续经营净利润（净亏损以“-”号填列）",
				grade: '25',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_25_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_25_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "（二）终止经营净利润（净亏损以“-”号填列）",
				grade: '26',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_26_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_26_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "五、其他综合收益的税后净额",
				grade: '27',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_27_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_27_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "（一）不能重分类进损益的其他综合收益",
				grade: '28',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_28_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_28_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "1．重新计量设定受益计划变动额",
				grade: '29',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_29_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_29_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "2．权益法下不能转损益的其他综合收益",
				grade: '30',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_30_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_30_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "3．其他权益工具投资公允价值变动",
				grade: '31',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_31_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_31_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "4．企业自身信用风险公允价值变动",
				grade: '32',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_32_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_32_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "（二）将重分类进损益的其他综合收益",
				grade: '33',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_33_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_33_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "1．权益法下可转损益的其他综合收益",
				grade: '34',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_34_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_34_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "2．其他债权投资公允价值变动",
				grade: '35',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_35_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_35_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "3．金融资产重分类计入其他综合收益的金额",
				grade: '36',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_36_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_36_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "4．其他债权投资信用减值准备",
				grade: '37',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_37_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_37_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "5．现金流量套期储备",
				grade: '38',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_38_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_38_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "6．外币财务报表折算差额",
				grade: '39',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_39_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_39_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "六、综合收益总额",
				grade: '40',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_40_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_40_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "七、每股收益：",
				grade: '41',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_41_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_41_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "（一）基本每股收益",
				grade: '42',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_42_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_42_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "（二）稀释每股收益",
				grade: '43',
				disabledcwbbyzx_1_x_1: false,
				disabledcwbbyzx_1_x_2: false,
				cwbbyzx_1_x_1: {
					cellCode: "cwbbwxz_1_43_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_1_x_2: {
					cellCode: "cwbbwxz_1_43_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}
		]
	}
	return obj
}
